<template>
    <div class="auth-page" :class="{ mobile: isMobileLayout }">
        <div class="auth-card">
            <div class="title_box">
                <p>
                    <i class="iconfont icon-r-team auth-brand-icon">
                    </i>
                    登录影院用户端
                </p>
            </div>
            <!-- 登录表单区域 -->
            <el-form
                class="auth-form"
                :model="loginForm"
                :rules="loginFormRules"
                ref="loginFormRef"
            >
                <!-- 用户名 -->
                <el-form-item prop="userName">
                    <div class="input-row">
                        <i
                            class="iconfont icon-r-user1 input-icon"
                        ></i>
                        <el-input
                            v-model="loginForm.userName"
                            placeholder="请输入用户名"
                            clearable
                        ></el-input>
                    </div>
                </el-form-item>
                <!-- 密码 -->
                <el-form-item prop="password">
                    <div class="input-row">
                        <i
                            class="iconfont icon-r-lock input-icon"
                        ></i>
                        <el-input
                            v-model="loginForm.password"
                            type="password"
                            placeholder="请输入密码"
                            show-password
                        ></el-input>
                    </div>
                </el-form-item>
                <!-- 按扭区域 -->
                <el-form-item class="btns">
                    <el-button
                        class="auth-btn"
                        :round="true"
                        type="primary"
                        @click="login"
                    >
                        登录</el-button
                    >
                    <el-button
                        class="auth-btn"
                        :round="true"
                        type="info"
                        @click="registerAccount"
                    >
                        注册新用户</el-button
                    >
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
export default {
    name: "Login",
    data() {
        return {
            // 登录表单数据对象
            loginForm: {
                userName: "",
                password: "",
            },
            // 登录表单验证规则
            loginFormRules: {
                // 验证用户名格式
                userName: [
                    {
                        required: true,
                        message: "请输入用户名称",
                        trigger: "blur",
                    },
                    {
                        min: 2,
                        max: 20,
                        message: "用户名称长度在2到20个字符之间",
                        trigger: "blur",
                    },
                ],
                // 验证密码格式
                password: [
                    { required: true, message: "请输入密码", trigger: "blur" },
                    {
                        min: 6,
                        max: 16,
                        message: "登录密码长度在6到16个字符之间",
                        trigger: "blur",
                    },
                ],
            },
            sessionId: 0,
        };
    },
    computed: {
        isMobileLayout() {
            return this.$platform.isMobile;
        },
    },
    created() {
        this.sessionId = window.sessionStorage.getItem("sessionId");
        window.sessionStorage.setItem("sessionId", 0);
    },
    methods: {
        success(params) {
            this.login();
        },
        login() {
            this.$refs.loginFormRef.validate(async (valid) => {
                if (!valid) return;
                axios.defaults.headers.post["Content-Type"] =
                    "application/json";
                const { data: res } = await axios.post(
                    "sysUser/login",
                    JSON.stringify(this.loginForm)
                );
                if (res.code !== 200) return this.$message.error(res.msg);

                this.$message.success({ message: "登录成功", duration: 1000 });
                // 保存token
                window.sessionStorage.setItem("token", res.data.token);
                res.data.sysUser.sysRole = null;
                window.sessionStorage.setItem(
                    "loginUser",
                    JSON.stringify(res.data.sysUser)
                );
                if (
                    this.sessionId !== 0 &&
                    this.sessionId !== "0" &&
                    this.sessionId !== null
                ) {
                    this.$router.push("/chooseSeat/" + this.sessionId);
                    return;
                }
                // 导航跳转到首页
                this.$router.push("/welcome");
            });
        },
        registerAccount() {
            this.$router.push("/register");
        },
    },
};
</script>

<style scoped>
.auth-page {
    background: url("../assets/login-background.jpg");
    background-size: cover;
    background-position: center;
    min-height: 100%;
    padding: 24px 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.auth-card {
    width: 100%;
    max-width: 450px;
    min-height: 300px;
    background-color: #fff;
    border-radius: 16px;
    border: 1px solid grey;
    padding: 28px 24px 24px;
    box-shadow: 0 16px 40px rgba(15, 23, 42, 0.16);
}

.title_box {
    text-align: center;
    font-size: 32px;
    margin-bottom: 28px;
}

.title_box p {
    margin: 0;
}

.auth-brand-icon {
    font-size: 36px;
}

.auth-form {
    width: 100%;
}

.input-row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.input-icon {
    font-size: 28px;
    color: grey;
}

.btns {
    margin-top: 24px;
}

.auth-btn {
    min-width: 140px;
    font-size: 22px;
    white-space: nowrap;
}

.btns >>> .el-form-item__content {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 12px;
    width: 100%;
    margin-left: 0 !important;
}

.auth-page.mobile {
    padding: 16px;
}

.auth-page.mobile .auth-card {
    border-radius: 14px;
    padding: 24px 18px 20px;
}

.auth-page.mobile .title_box {
    font-size: 26px;
    margin-bottom: 20px;
}

.auth-page.mobile .btns {
    margin-top: 20px;
}

.auth-page.mobile .auth-btn {
    flex: 1 1 0;
    width: 0;
    margin-left: 0;
    min-width: 0;
    font-size: 14px;
    padding: 12px 0;
}

.auth-page.mobile .input-row {
    gap: 10px;
}

.auth-page.mobile .input-icon {
    font-size: 20px;
}

.auth-page.mobile .auth-brand-icon {
    font-size: 28px;
}

.auth-page.mobile .btns .el-button + .el-button {
    margin-left: 0;
}

.auth-page.mobile .btns >>> .el-form-item__content {
    gap: 10px;
}
</style>
